<script setup lang="ts">
import { computed, ref, onMounted } from 'vue';
import { BFormInput } from 'bootstrap-vue-next';
import type { IColumnDefinition, RowData, INumberColumn } from '../types';

const props = defineProps<{
  modelValue: any;
  row: RowData;
  column: IColumnDefinition;
  autofocus?: boolean;
}>();
const emit = defineEmits(['update:modelValue', 'change']);
const inputRef = ref<any>(null);

const col = computed(() => props.column as INumberColumn);

const currentValue = computed({
  get: () => props.modelValue,
  set: (val) => emit('update:modelValue', val === '' ? null : Number(val)),
});

onMounted(() => {
  if (props.autofocus && inputRef.value) {
    const el = inputRef.value;
    if (el.element && el.element.focus) {
      el.element.focus();
    } else if (el.focus) {
      el.focus();
    }
  }
});
</script>

<template>
  <BFormInput
    ref="inputRef"
    v-model="currentValue"
    type="number"
    size="sm"
    class="text-end"
    :name="col.name"
    :placeholder="col.placeholder"
    :disabled="col.editorIsDisabled ? col.editorIsDisabled(row) : false"
    @change="emit('change', currentValue)"
    @click.stop
  />
</template>
